"use strict";

var Loading = function () {

  var calculate_totals = function() {
    var $total_pack   = 0;
    var $total_weight = 0;
    var $total_volume = 0;
    var $total_desi   = 0;
    var $total_ladameter = 0;
    var trans_method = $('#loading_trans_mode').val();
    if (trans_method === undefined) {
      var trans_method = $('.operation-select').find('option:selected').attr('trans_method');
    }

    var current_length_unit = $('.measure_length').is(":checked") ? 'in' : 'cm';
    var current_weight_unit = $('.measure_weight').is(":checked") ? 'lb' : 'kg';

    $(".package-field").each(function(pack) {
      var $dimension1, $dimension2, $dimension3, $pack_count, $stackable_option, $brut_weight;
      var $unit_volume = 0;
      var $pack_volume = 0;
      var $unit_desi   = 0;
      var $desi_volume = 0;
      var $unit_ladameter = 0;
      var $stackable_rows = 1;

      if ($(".package-field").find('.removable_item')[pack].value !== 'true') {
        $pack_count  = parseFloat($(".package-field").find(".pack-total")[pack].value || 0);
        $brut_weight = parseFloat($(".package-field").find(".pack-brutwg")[pack].value || 0);
        $dimension1  = parseFloat($(".package-field").find(".pack-dimension1")[pack].value || 0);
        $dimension2  = parseFloat($(".package-field").find(".pack-dimension2")[pack].value || 0);
        $dimension3  = parseFloat($(".package-field").find(".pack-dimension3")[pack].value || 0);
        if(typeof $(".package-field").find(".pack-stackable")[pack] !== 'undefined' && $(".package-field").find(".pack-stackable")[pack] !== null) {
          $stackable_option = $(".package-field").find(".pack-stackable")[pack].value;
        }

        switch ($stackable_option) {
          case "not_stackable":
            $stackable_rows = 1;
            break;
          case "top_stackable":
            $stackable_rows = 1;
            break;
          case "stackable":
            $stackable_rows = 1;
            break;
          case "stackable2":
            $stackable_rows = 2;
            break;
          case "stackable3":
            $stackable_rows = 3;
            break;
          case "stackable4":
            $stackable_rows = 4;
            break;
          case "stackable5":
            $stackable_rows = 5;
            break;
          case "stackable6":
            $stackable_rows = 6;
            break;
          case "stackable7":
            $stackable_rows = 7;
            break;
          case "stackable8":
            $stackable_rows = 8;
            break;
          case "stackable9":
            $stackable_rows = 9;
            break;
          case "stackable10":
            $stackable_rows = 10;
            break;
          default:
            $stackable_rows = 0;
            break;
        }
      }
      if ($dimension1 > 0 || $dimension2 > 0 || $dimension3 > 0) {
        if (current_length_unit === 'in') {
          $unit_volume = (parseFloat($dimension1) * parseFloat($dimension2) * parseFloat($dimension3) * parseFloat($pack_count)) / 1728;
        } else {
          $unit_volume = (parseFloat($dimension1) * parseFloat($dimension2) * parseFloat($dimension3) * parseFloat($pack_count)) / 1000000;
        }
        if (trans_method == "courier") {
          if (current_length_unit === 'in') {
            $desi_volume = (parseFloat($dimension1) * parseFloat($dimension2) * parseFloat($dimension3) * parseFloat($pack_count)) / 1728;
            $unit_desi = measure_units_conversion(current_weight_unit, $desi_volume) / 5000
          } else {
            $unit_desi = (parseFloat($dimension1) * parseFloat($dimension2) * parseFloat($dimension3) * parseFloat($pack_count)) / 5000;
          }
          
          if ($stackable_rows < 1) {
            $stackable_rows = 1;
          }
        }
      }
      if(typeof $(".package-field").find(".pack-volume")[pack] !== 'undefined' && $(".package-field").find(".pack-volume")[pack] !== null) {
        if ($unit_volume > 0) {
          $(".package-field").find(".pack-volume")[pack].value = $unit_volume.toFixed(2);
        }
        $pack_volume = parseFloat($(".package-field").find(".pack-volume")[pack].value || 0);
      }
      
      if (($dimension1 > 0 || $dimension2 > 0) && ($stackable_rows > 0)) {
        $unit_ladameter = ((parseFloat($dimension1) * parseFloat($dimension2)) / parseFloat($stackable_rows) / 24000);
      }
      if ($pack_count > 0) {
        $total_pack      += parseFloat($pack_count);
        $total_volume    += parseFloat($pack_volume);
        $total_desi      += parseFloat($unit_desi);
        $total_ladameter += (parseFloat($unit_ladameter) * parseFloat($pack_count));
        $total_weight    += parseFloat($brut_weight);
        if (trans_method != "road" && trans_method != undefined) {
          $total_ladameter = 0
        }
      }
    });

    if ($total_ladameter > 13.6) {
      $total_ladameter = 13.6;
    }

    var $container_total_pack = 0;

    $(".container-field").each(function(pack) {
      $container_total_pack = parseFloat($(".container-field").find(".pack-total")[pack].value || 0);
      if ($container_total_pack > 0) {
        $total_pack      = 0;
        $total_volume    = 0;
        $total_weight    = 0;
        $total_ladameter = 0;
      }
    });

    $(".container-field").each(function(pack) {
      var $pack_count, $brut_weight;
      var $pack_volume = 0;
      if ($(".container-field").find('.removable_item')[pack].value !== 'true') {
        $pack_count = parseFloat($(".container-field").find(".pack-total")[pack].value || 0);
        $brut_weight = parseFloat($(".container-field").find(".pack-brutwg")[pack].value || 0);
      }
      $pack_volume = parseFloat($(".container-field").find(".pack-volume")[pack].value || 0);

      if ($pack_count > 0) {
        $total_pack      += parseFloat($pack_count);
        $total_volume    += parseFloat($pack_volume);
        $total_weight    += parseFloat($brut_weight);
        $total_ladameter = 0;
      }
    });

    $(".total-pack").val($total_pack.toFixed(2));
    $(".total-brut-weight").val($total_weight.toFixed(2));
    $(".total-volume").val($total_volume.toFixed(2));
    $(".total-ladameter").val($total_ladameter.toFixed(2));
    if (trans_method === "courier") {
      $(".total-ladameter").val($total_desi .toFixed(2));
    }
    calculate_price_wg();
  };

  var calculate_price_wg = function() {
    var total_volume        = parseFloat($(".total-volume").val()) || 0;
    var total_ladameter     = parseFloat($(".total-ladameter").val()) || 0;
    var total_brut_weight   = parseFloat($(".total-brut-weight").val()) || 0;
    var volume_weight       = 0;
    var ladametre_weight    = 0;
    var diff_ladameter      = 0;
    var trans_method        = $('#loading_trans_mode').val() || $('.operation-select option:selected').attr('trans_method') || $('#lead_lead_operation').val();

    var current_length_unit = $('.measure_length').is(":checked") ? 'in' : 'cm';
    var current_weight_unit = $('.measure_weight').is(":checked") ? 'lb' : 'kg';

    if (current_length_unit === 'in') {
      total_volume = total_volume / 35.315
    }

    if (current_weight_unit === 'lb') {
      total_brut_weight = total_brut_weight * 0.45359237
    }

    if (trans_method === "air") {
      volume_weight = total_volume / 0.006;
    } else if (trans_method === "sea") {
      volume_weight = total_volume * 1000;
    } else if (trans_method === "courier") {
      volume_weight = Math.ceil(total_ladameter);

      if (total_ladameter < 10) {
        diff_ladameter = total_ladameter - Math.floor(total_ladameter);
        if (diff_ladameter < 0.5) {
          volume_weight -= 0.5;
        }
      }
    } else {
      volume_weight = total_volume / 0.003;
    }
    if (trans_method === "courier") {
      ladametre_weight = total_ladameter;
    } else {
      ladametre_weight = total_ladameter * 1750;
    }

    var weightArray = [total_brut_weight, volume_weight, ladametre_weight];
    var max_weight = Math.max.apply(Math, weightArray);

    if (trans_method === "air") {
      max_weight = Math.round(max_weight + 0.40);
    }

    // Son hesaplanan ağırlığı ilgili input alanına yerleştir
    $(".total-chargable-weight").val(max_weight.toFixed(2));

  };

  var measure_units_conversion = function(weight_type, volume) {
    if (weight_type === 'lb') {
      return volume * 1728 * 16.387064 * 2.20462;
    } else {
      return volume * 1728 * 16.387064;
    }
  }

  var set_operational_fields = function() {
    var trans_method = $('#loading_trans_mode').val();
    if (trans_method === undefined || trans_method === null || trans_method === "") {
      var trans_method = $('input[type=radio][name="loading[trans_mode]"]:checked').val();
    }
    if (trans_method === undefined || trans_method === null || trans_method === "") {
      var trans_method = $('#loading_operation_id').find('option:selected').attr('trans_method');
    }
    var trans_type = $('#loading_operation_id').find('option:selected').attr('trans_type');
    if (trans_type === "domestic") {
      $('.trans_type_inter').hide();
      $('.country_selection').hide();
    } else {
      $('.trans_type_inter').show();
      $('.country_selection').show();
    }
    switch (trans_method) {
      case "rail":
        $('.loading_vagon_no').show();
        $("label[for=loading_vagon_no]").html("Vagon");
        $('#loading_in_container_div').show();
        $('#loading_in_container').val('out_of_container').trigger('change');
        $('.sea_position_attributes').hide();
        $("#loading_load_place_type option[value='other']").length && $("#loading_load_place_type").val("rail").trigger('change');
        $("#loading_unload_place_type option[value='other']").length && $("#loading_unload_place_type").val("rail").trigger('change');
        $("#loading_type").show();
        $('#assign').hide();
        break;
      case "air":
        $('.loading_vagon_no').show();
        $("label[for=loading_vagon_no]").html("HAWB No");
        $('#loading_in_container_div').hide();
        $('#loading_in_container').val('out_of_container').trigger('change');
        $('.sea_position_attributes').hide();
        $("#loading_load_place_type option[value='other']").length && $("#loading_load_place_type").val("air").trigger('change');
        $("#loading_unload_place_type option[value='other']").length && $("#loading_unload_place_type").val("air").trigger('change');
        $("#loading_type").hide();
        $('#assign').show();
        break;
      case "sea":
        $('.loading_vagon_no').show();
        $("label[for=loading_vagon_no]").html("House No");
        $('#loading_in_container_div').show();
        var trans_mode_input = $('#loading_trans_mode');
        if (trans_mode_input.length === 0) {
          $('#loading_in_container').val('at_container').trigger('change');
        }
        $('.sea_position_attributes').show();
        $("#loading_load_place_type option[value='other']").length && $("#loading_load_place_type").val("sea").trigger('change');
        $("#loading_unload_place_type option[value='other']").length && $("#loading_unload_place_type").val("sea").trigger('change');
        $("#loading_type").show();
        $('#assign').hide();
        break;
      case "courier":
        $('.loading_vagon_no').show();
        $("label[for=loading_vagon_no]").html("HAWB No");
        $("label[for=loading_ladameter]").html("Deci");
        $('#loading_in_container_div').hide();
        $('#loading_in_container').val('out_of_container').trigger('change');
        $('.sea_position_attributes').hide();
        $("#loading_load_place_type option[value='other']").length && $("#loading_load_place_type").val("other").trigger('change');
        $("#loading_unload_place_type option[value='other']").length && $("#loading_unload_place_type").val("other").trigger('change');
        $("#loading_load_type").val("P").trigger('change');
        $('.trans_type_inter').hide();
        $('.country_selection').show();
        $("#loading_type").show();
        $('#assign').hide();
        break;
      default:
        $('.loading_vagon_no').hide();
        $('#loading_in_container_div').show();
        $('#loading_in_container').val('out_of_container').trigger('change');
        $('.sea_position_attributes').hide();
        $("#loading_type").show();
        if ($('#loading_leadline_id').val() === "") {
          $("#loading_load_place_type option[value='other']").length && $("#loading_load_place_type").val("other").trigger('change');
          $("#loading_unload_place_type option[value='other']").length && $("#loading_unload_place_type").val("other").trigger('change');
        }
        $('#assign').hide();
    }
  };

  var set_vessel_type_fields = function() {
    var trans_method = $('#loading_trans_mode').val();
    if (trans_method === undefined) {
      var trans_method = $('#loading_operation_id').find('option:selected').attr('trans_method');
    }
    if ($("#loading_load_type").val() === "K" && trans_method === "road") {
      $("#loading_vessel_type_div").show();
    } else {
      $("#loading_vessel_type_div").hide();
    }
  };

  var set_company_address = function(company_data, address_type) {
    if (address_type === "loading") {
      var city_id   = company_data['city_id'];
      var city_name = company_data['city_name'];
      $('#loading_load_place').val(company_data['address']);
      $('#loading_dep_zipcode').val(company_data['postcode']);
      $('#loading_load_coun').val(company_data['country_id']).trigger('change');
      $('#loading_load_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
      $('#loading_dep_lat').val(company_data['lat']);
      $('#loading_dep_lng').val(company_data['lng']);
    }
    if (address_type === "unloading") {
      var city_id   = company_data['city_id'];
      var city_name = company_data['city_name'];
      $('#loading_unload_place').val(company_data['address']);
      $('#loading_arv_zipcode').val(company_data['postcode']);
      $('#loading_unload_coun').val(company_data['country_id']).trigger('change');
      $('#loading_unload_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
      $('#loading_arv_lat').val(company_data['lat']);
      $('#loading_arv_lng').val(company_data['lng']);
    }
    if (address_type === "origin_company_locations") {
      var city_id   = company_data['city_id'];
      var city_name = company_data['city_name'];
      $('#point_origin_address').val(company_data['address']);
      $('#point_origin_postcode').val(company_data['postcode']);
      $('#point_origin_country_id').val(company_data['country_id']).trigger('change');
      $('#point_origin_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
      $('#point_origin_lat').val(company_data['lat']);
      $('#point_origin_lng').val(company_data['lng']);
    }
    if (address_type === "destination_company_locations") {
      var city_id   = company_data['city_id'];
      var city_name = company_data['city_name'];
      $('#point_destination_address').val(company_data['address']);
      $('#point_destination_postcode').val(company_data['postcode']);
      $('#point_destination_country_id').val(company_data['country_id']).trigger('change');
      $('#point_destination_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
      $('#point_destination_lat').val(company_data['lat']);
      $('#point_destination_lng').val(company_data['lng']);
    }
    if (address_type === "good_sender") {
      $('#good_sender_address').val(company_data['address']);
      $('#good_sender_postcode').val(company_data['postcode']);
      $('#good_sender_city').val(company_data['city_name']);
      $('#good_sender_name').val(company_data['name']);
      $('#good_sender_taxno').val(company_data['taxno']);
      $('#good_sender_country_id').val(company_data['country_id']).trigger('change');
    }
    if (address_type === "good_consignee") {
      $('#good_consignee_address').val(company_data['address']);
      $('#good_consignee_postcode').val(company_data['postcode']);
      $('#good_consignee_city').val(company_data['city_name']);
      $('#good_consignee_name').val(company_data['name']);
      $('#good_consignee_taxno').val(company_data['taxno']);
      $('#good_consignee_country_id').val(company_data['country_id']).trigger('change');
    }
  };

  var show_company_financial_details = function(company_field) {
    var fin_status   = $(company_field).select2('data')[0]['financial_status'];
    var fin_info_div = $(company_field).data('financial-detail');
    var fin_element  = $("#company_financial_details");

    if(typeof fin_element !== 'undefined' && fin_element !== null) {
      fin_element.className = "alert alert-warning padding-0";
      if (fin_status != 'active' && fin_info_div != undefined) {
        $('#' + fin_info_div).html($(company_field).select2('data')[0]['financial_notes']);
      }
    }
    var branch_field = $('#'+$(company_field).data('branch-field'));
    if(typeof branch_field !== 'undefined' && branch_field !== null) {
      branch_field.val($(company_field).select2('data')[0]['branch_id']).trigger('change');
    }
  };
  
  var set_location_hint = function (address, select_id) {
    var select = $('#' + select_id)
    var company_address = address === '' ? 'No address' : address;
    select.parent('div').find('.location_hint').remove();
    select.parent('div').append('<span id="location_hint" class="location_hint help-block text-warning error-inputs truncate">' + company_address + '</span>');
  }

  var set_place_address = function(address_type, place_id, place_name, place_type, place_address, place_city_id, place_city_name, place_state_name, place_country_id, place_postcode, place_latitude, place_longitude) {
    if (address_type === "loader_locations" || address_type === "sender_locations") {
      $("select[data-address-role='origin_place_type']").val(place_type).trigger('change');
      $("input[data-address-role='origin_address']").val(place_address);
      $("input[data-address-role='origin_postcode']").val(place_postcode);
      $("input[data-address-role='origin_city_id']").val(place_city_id);
      $("select[data-address-role='origin_city_id']").val(place_city_id).trigger('change');
      $("input[data-address-role='origin_city_name']").val(place_city_name);
      $("select[data-address-role='origin_country_id']").val(place_country_id).trigger('change');
      $("input[data-address-role='origin_country_id']").val(place_country_id)
      $("input[data-address-role='origin_latitude']").val(place_latitude);
      $("input[data-address-role='origin_longitude']").val(place_longitude);
      $("select[data-address-role='origin_place_id']").append("<option value='" + place_id + "' selected>" + place_name + "</option>").trigger('change');
      $("input[data-address-role='origin_place_name']").val(place_name);
      $("input[data-address-role='origin_state_name']").val(place_state_name);

      var select_ids = ["position_coagent_id", "loading_loader_id"]
      $.each(select_ids, function(index, value) {
        set_location_hint(place_address, value);
      });
    }
    if (address_type === "delivery_locations" || address_type === "consignee_locations") {
      $("select[data-address-role='destination_place_type']").val(place_type).trigger('change');
      $("input[data-address-role='destination_address']").val(place_address);
      $("input[data-address-role='destination_postcode']").val(place_postcode);
      $("input[data-address-role='destination_city_id']").val(place_city_id);
      $("select[data-address-role='destination_city_id']").append("<option value='" + place_city_id + "' selected>" + place_city_name + "</option>").trigger('change');
      $("input[data-address-role='destination_city_name']").val(place_city_name);
      $("select[data-address-role='destination_country_id']").val(place_country_id).trigger('change');
      $("input[data-address-role='destination_country_id']").val(place_country_id);
      $("input[data-address-role='destination_latitude']").val(place_latitude);
      $("input[data-address-role='destination_longitude']").val(place_longitude);
      $("select[data-address-role='destination_place_id']").append("<option value='" + place_id + "' selected>" + place_name + "</option>").trigger('change');
      $("input[data-address-role='destination_place_name']").val(place_name);
      $("input[data-address-role='destination_state_name']").val(place_state_name);

      var select_ids = ["position_agent_id", "loading_delivery_id"]
      $.each(select_ids, function(index, value) {
        set_location_hint(place_address, value);
      });
    }
    if (address_type === "company_locations") {
      $("input[data-address-role='company_address']").val(place_address);
      $("input[data-address-role='company_postcode']").val(place_postcode);
      $("select[data-address-role='company_country_id']").val(place_country_id).trigger('change');
      $("input[data-address-role='company_country_id']").val(place_country_id);
      $("select[data-address-role='company_city_id']").append("<option value='" + place_city_id + "' selected>" + place_city_name + "</option>").trigger('change');
      $("input[data-address-role='company_city_name']").val(place_city_name);
      $("select[data-address-role='company_country_id']").val(place_country_id).trigger('change');
      $("input[data-address-role='company_latitude']").val(place_latitude);
      $("input[data-address-role='company_longitude']").val(place_longitude);
      $("select[data-address-role='company_place_id']").append("<option value='" + place_id + "' selected>" + place_name + "</option>").trigger('change');
    }
  };

  var set_nested_place_address = function(address_type, place_id, place_name, place_type, place_address, place_city_id, place_address_name, place_state_name, place_country_id, place_postcode, place_address_latitude, place_longitude) {
    $('input[data-address-role="nested_address"][id="' + address_type.replace("locations", "address") + '"]').val(place_address);
    $('input[data-address-role="nested_postcode"][id="' + address_type.replace("locations", "postcode") + '"]').val(place_postcode);
    $('select[data-address-role="nested_country_id"][id="' + address_type.replace("locations", "country_id") + '"]').val(place_country_id).trigger('change');
    $('input[data-address-role="nested_country_id"][id="' + address_type.replace("locations", "country_id") + '"]').val(place_country_id);
    $('select[data-address-role="nested_city_id"][id="' + address_type.replace("locations", "city_id") + '"]').append("<option value='" + place_city_id + "' selected>" + place_address_name + "</option>").trigger('change');
    $('input[data-address-role="nested_city_name"][id="' + address_type.replace("locations", "city_name") + '"]').val(place_address_name);
    $('input[data-address-role="nested_latitude"][id="' + address_type.replace("locations", "latitude") + '"]').val(place_address_latitude);
    $('input[data-address-role="nested_longitude"][id="' + address_type.replace("locations", "longitude") + '"]').val(place_longitude);
    $('select[data-address-role="nested_place_id"][id="' + address_type.replace("locations", "place_id") + '"]').append("<option value='" + place_id + "' selected>" + place_name + "</option>").trigger('change');
    $('input[data-address-role="nested_name"][id="' + address_type.replace("locations", "name") + '"]').val(place_name);
    $('input[data-address-role="nested_state_name"][id="' + address_type.replace("locations", "state_name") + '"]').val(place_state_name);

    set_location_hint(place_address, address_type.replace("locations", "company_id"));
  };

  var set_adr_fields = function() {
    if ($('#loading_commodity_type').val() === "adr" || $('#tender_commodity_type').val() == "adr") {
      $('.loading_adr_fields').show();
    } else {
      $('.loading_adr_fields').hide();
    }
  }

  var set_origin_fields = function() {
    var place_type = $("#loading_load_place_type").val();
    if (place_type === "other") {
      $('.load_place_id_div').hide();
      $('#loading_load_place_id').val(null).trigger('change');
      $('.load_place_div').show();
      $('.load_postcode_div').show();
      $('.load_city_id_div').show();
    } else {
      $('.load_place_id_div').show();
      $('.load_place_div').hide();
      $('.load_postcode_div').hide();
      $('.load_city_id_div').hide();
      $('#loading_load_place_id').data('place-type', place_type);
    }
  }

  var set_destination_fields = function() {
    var place_type = $("#loading_unload_place_type").val();
    if (place_type === "other") {
      $('.unload_place_id_div').hide();
      $('#loading_unload_place_id').val(null).trigger('change');
      $('.unload_place_div').show();
      $('.unload_postcode_div').show();
      $('.unload_city_id_div').show();
    } else {
      $('.unload_place_id_div').show();
      $('.unload_place_div').hide();
      $('.unload_postcode_div').hide();
      $('.unload_city_id_div').hide();
      $('#loading_unload_place_id').data('place-type', place_type);
    }
  }

  var get_company_locations = function(company_id, target_list) {
    if (company_id == null || company_id == '' || company_id == undefined) {
      $("[data-role='"+ target_list +"']").hide();
      return false;
    } else {
      return $.ajax({
        type: "GET",
        url: "/places?list_scope="+ target_list +"&company_id=" + company_id,
        dataType: "script"
      });
    }
  }

  var in_container_change = function () {
    var inContainer = $('#loading_in_container').val();

    console.log(inContainer);
    if ( inContainer === "at_container") {
      $('.container_nested_form').show();
      $('.container_speficied_field').show();
      $('.pack_details').hide();
      $('#loading_has_container_nos').trigger('change');
    } else if (inContainer === "out_of_container") {
      $('.pack_details').show();
      $('.container_nested_form').hide();
      $('.container_speficied_field').hide();
      $('.container_summary_fields').hide();
    } else {
      $('.pack_details').hide();
      $('.container_nested_form').hide();
      $('.container_speficied_field').hide();
      $('.container_summary_fields').hide();
    }
  }

  return {
    init: function () {
      $(document).on("change", ".change-total", function(event) {
        calculate_totals();
      });
      $(document).on("change", ".total-ladameter", function(event) {
        calculate_price_wg();
      });
      $(document).on("change", ".total-volume", function(event) {
        calculate_price_wg();
      });
      $(document).on('change', '.measure_length', function() {
        calculate_totals();
      });
      $(document).on('change', '.measure_weight', function() {
        calculate_totals();
      });

      $(document).on("change", ".company-select", function(event) {
        show_company_financial_details(this);
      });

      $(document).on("change", "#loading_commodity_type, #tender_commodity_type", function(event) {
        set_adr_fields();
      });
      set_adr_fields();

      $(document).on('change', '#loading_in_container', function(event) {
        in_container_change();
      });
      in_container_change();

      $(document).on('change', '[name="loading[trans_mode]"]', function() {
        in_container_change();
        set_operational_fields();
      });
      set_operational_fields();

      $(document).on('change', '#loading_has_container_nos', function(event) {
        if ($('#loading_has_container_nos').val() === "no") {
          $('.container_summary_fields').show();
          $('.container_nested_form').hide();
        } else {
          $('.container_nested_form').show();
          $('.container_summary_fields').hide();
        }
      });

      $(document).on("change", "#loading_operation_id", function(event) {
        set_operational_fields();
        set_vessel_type_fields();
      });

      $(document).on("change", '[name="loading[load_type]"]', function(event) {
        set_vessel_type_fields();
        in_container_change();
      });
      set_vessel_type_fields();

      $(document).on("change", "#loading_load_place_type", function(event) {
        set_origin_fields();
      });
      set_origin_fields();
      

      $(document).on("change", "#loading_unload_place_type", function(event) {
        set_destination_fields();
      });
      set_destination_fields();

      $(document).on('click', '.remove_nested_item', function(event) {
        if ($(this).parent().children('.removable_item')[0].value === 'true') {
          calculate_totals();
          $(this).parent().children('.removable_item')[0].value = 'true';
          $(this).closest('.package-line').hide();
          event.preventDefault();
        }
      });

      $(document).ready(function() {
        return $('.search_input').on('keyup', function() {
          var value = $(this).val().toLowerCase();
          return $('#' + $(this).attr('search-table') + ' > div').filter(function() {
            return $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
          });
        });
      });
    },
    set_place_address: function (address_type, place_id, place_name, place_type, place_address, place_city_id, place_city_name, place_state_name, place_country_id, place_postcode, place_latitude, place_longitude) {
      set_place_address(address_type, place_id, place_name, place_type, place_address, place_city_id, place_city_name, place_state_name, place_country_id, place_postcode, place_latitude, place_longitude);
    },
    set_nested_place_address: function (address_type, place_id, place_name, place_type, place_address, place_city_id, place_address_name, place_state_name, place_country_id, place_postcode, place_address_latitude, place_longitude) {
      set_nested_place_address(address_type, place_id, place_name, place_type, place_address, place_city_id, place_address_name, place_state_name, place_country_id, place_postcode, place_address_latitude, place_longitude);
    },
    set_company_address: function (company_data, address_type) {
      set_company_address(company_data, address_type);
    },
    get_company_locations: function (company_id, target_list) {
      get_company_locations(company_id, target_list);
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Loading;
}